var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 0.5H0.75C0.551088 0.5 0.360322 0.587797 0.21967 0.744078C0.0790178 0.900358 0 1.11232 0 1.33333V3.49167C0 3.9275 0.15975 4.35583 0.43725 4.66417L4.5 9.17833V15.5C4.50015 15.642 4.53291 15.7816 4.59517 15.9055C4.65744 16.0295 4.74716 16.1338 4.85583 16.2085C4.9645 16.2832 5.08853 16.3258 5.21618 16.3323C5.34382 16.3389 5.47086 16.3091 5.58525 16.2458L8.58525 14.5792C8.8395 14.4375 9 14.1492 9 13.8333V9.17833L13.0628 4.66417C13.3403 4.35583 13.5 3.9275 13.5 3.49167V1.33333C13.5 1.11232 13.421 0.900358 13.2803 0.744078C13.1397 0.587797 12.9489 0.5 12.75 0.5ZM7.71975 8.24417C7.64997 8.32142 7.59463 8.41325 7.55691 8.51436C7.5192 8.61548 7.49986 8.72388 7.5 8.83333V13.3183L6 14.1517V8.83333C6.00014 8.72388 5.9808 8.61548 5.94309 8.51436C5.90537 8.41325 5.85003 8.32142 5.78025 8.24417L1.5 3.49167V2.16667H12.0008L12.0023 3.48583L7.71975 8.24417Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter_icon.28effd3ffbac8a9c3b4658c9ef54d2e1.svg";
export { ForwardRef as ReactComponent };